import Vue from "vue"
import $router from './router'
import $store from '@/store'
import capacitorService from '@/services/capacitor-service'
import { Filesystem, Directory } from '@capacitor/filesystem'
import { FileOpener } from '@capacitor-community/file-opener'

export const eventBusUtility = new Vue({
    data() {
        return {
            comparators: {
                eq: (a, b) => a === b,
                neq: (a, b) => a !== b,
                gt: (a, b) => a > b,
                date_gt_today: (a, b) => moment().isBefore(a, 'day')
            },
            bg_colors: [
                'primary lighten-1',
                'primary darken-1',
                'teal accent-3', 
                'red lighten-1', 
                'purple lighten-3', 
                'deep-purple lighten-3', 
                'indigo lighten-4', 
                'blue lighten-4', 
                'teal lighten-3'
            ],
            asyncDebounce: {}
        }
    },

    computed: {
        strcutshow() {
            if(this.isHydrated) {
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs': return 35
                    case 'sm': return 48
                    case 'md': return 65
                    case 'lg': return 100
                    case 'xl': return 150
                    default:
                        return 150
                }
            } else {
                return 150
            }
        },

        currentColorMode() {
            let app_color = $store.getters.getSetting('app_color')
            if(!app_color) {
                app_color = '#ffc107'
            }
            return this.lightOrDark(app_color)
        },

		iconAppBarColor() {
            if(this.currentColorMode == 'dark') {
                return 'white--text'
            } else return 'black--text'
		},
    },

    methods: {

        asyncSearch(field, search) {
			if(typeof field.async !== 'undefined' && field.async) {
				// Controllo del numero minimo di caratteri per la ricerca
				// Usa la configurazione solo per il campo product_id, altrimenti default a 1
				const minChars = field.key === 'product_id' 
					? ($store.getters.getSetting('product_search_min_chars') || 1)
					: 1
				
				// Se la stringa di ricerca è troppo corta, non procedo
				if (!search || search.length < minChars) {
					Vue.set(field, 'searching', false)
					field.options = []
					return
				}

                Vue.set(field, 'searching', true)
				if(this.asyncDebounce[field.key]) {
					clearTimeout(this.asyncDebounce[field.key])
				}

				this.asyncDebounce[field.key] = setTimeout(() => {
                    Vue.nextTick(() => {
                        this.$eventBusUtility.$emit('asyncSearched', {field, search})
                    })
					if(search) {  
                        let params =  {
                            search: search,
                        }
                        if(field.appends) {
                            params.appends = field.appends
                        }

						this.axios.get(field.async_url, {params}).then(response => {
							// field.options = response.data.options
							// Vue.set(field, 'options', response.data.options)
							Vue.set(field, 'searching', false)

                            const optionsToAdd = response.data.options
                            const currentOptions = field.options
                          
                            if (optionsToAdd.length + currentOptions.length <= 50) {
                                field.options = currentOptions.concat(optionsToAdd)
                            } else {
                                field.options = optionsToAdd.slice(0, 50)
                            }
                          
                            Vue.set(field, 'options', field.options)
						})
					} else {
                        Vue.set(field, 'searching', false)
						field.options = []
					}
				}, 300)
			}
		},

        webNotify(notification = {}) {
            let title = 'GiveMeHive! - Nuova Notifica'
            let body = (notification.title || '') + ' ' + (notification.subtitle || '') + ' ' + (notification.text || '')
            let options = {
                icon: '/img/cropped-favicon-192x192.png',
                body: body
            }

            // Let's check if the browser supports notifications
            if (!("Notification" in window)) {
                console.log("This browser does not support desktop notification");
            }
            
            // Let's check whether notification permissions have already been granted
            else if (Notification.permission === "granted") {
                // If it's okay let's create a notification
                try {
                    var browser_notification = new Notification(title, options);
                } catch (e) {
                    if (e.name == 'TypeError')
                        return false;
                }
            }
            
            // Otherwise, we need to ask the user for permission
            else if (Notification.permission !== 'denied') {
                Notification.requestPermission(function (permission) {
                    // If the user accepts, let's create a notification
                    if (permission === "granted") {
                        try {
                            var browser_notification = new Notification(title, options);
                        } catch (e) {
                            if (e.name == 'TypeError')
                                return false;
                        }
                    }
                });
            }

            if(typeof browser_notification !== 'undefined') {
                browser_notification.onclick = () => {
                    browser_notification.close()
                    window.focus()
                    this.goTo($router, notification.modelDef, notification.modelDefId)
                }
            }
            
            // At last, if the user has denied notifications, and you 
            // want to be respectful there is no need to bother them any more.
        },
        
        isNumber(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        },

        isJson(str) {
            try {
                JSON.parse(str)
            } catch (e) {
                return false
            }
            return true
        },
        
        // Select the header of the column in the table iteratively
        headerValue(key, item) {
            if(item) {
                if(key.includes('.')){
                    let index = key.indexOf('.')
                    let parent = key.slice(0, index)
                    return eventBusUtility.headerValue(key.slice(index+1), item[parent])
                }else if(Array.isArray(item)) {
                    let belongsToManyString = ''
                    _.forEach(item, function(value, i) {
                        belongsToManyString = belongsToManyString + value[key]
                        belongsToManyString += i === 0 ? ' ' : ', ';
                    });
                    return belongsToManyString
                }else {
                    return item[key]
                }
            }
            return null
        },

        // Calc background color of avatars
        bgColor(id) {
            return this.bg_colors[id % this.bg_colors.length]
        },

        dialogTitle(info) {
            if(info.labels) {
                return info.labels.modelTitle
            } else return ''
        },

        priorityColor(priority, type = '') {
            if(type === 'text') {
                type = '--text'
            } else if(type === 'color') {
                type = ''
            } else {
                type = ' priority'
            }
            switch (priority) {
                case 'a':
                return 'red'+type
                case 'b':
                return 'amber'+type
                case 'c':
                return 'green'+type
                case 'd':
                return 'blue'+type
                case 'e':
                return 'cyan'+type
            }
        },

        conditionColor(condition) {
            switch (condition) {
                case 'active':
                return 'green'
                case 'expiring':
                return 'amber'
                case 'expired':
                return 'red'
            }
        },

        deadlineTypeColor(type) {
            switch (type) {
                case 'credit':
                return 'green'
                case 'debit':
                return 'amber'
            }
        },

        colorOptionsRole(option_name) {
            switch(option_name) {
                case 'true':
                return 'green--text'
                case 'false':
                return 'red--text'
                case 'owner':
                return 'amber--text'
                case 'user':
                return 'blue--text'
                case 'users':
                return 'cyan--text'
                default:
                return 'X'
            }
        },

        mailStatus(type) {
            switch(type) {
                case 'sent':
                return 'teal--text text--accent-3'
                case 'sending':
                return 'light-blue--text text--accent-3'
                case 'pending':
                return 'orange--text text--lighten-2'
                case 'not_sent':
                return 'red--text text--lighten-2'
                case 'failed':
                return 'red--text text--accent-3'
                case 'accepted':
                return 'light-blue--text text--accent-3'
                case 'delivered':
                return 'green--text text--accent-3'
                case 'delivery_error':
                return 'deep-orange--text text--accent-3'
            }
        },

        whatsappStatus(type) {
            switch(type) {
                case 'whatsapp_sent':
                return 'teal--text text--accent-3'
                case 'whatsapp_delivered':
                return 'green--text text--accent-3'
                case 'whatsapp_read':
                return 'light-blue--text text--accent-3'
                case 'whatsapp_failed':
                return 'red--text text--lighten-2'
            }
        },

        businessCallqueueStatus(type) {
            switch(type) {
                case 0:
                return 'teal--text text--accent-3'
                case 1:
                return 'red--text text--lighten-2'
            }
        },
        
        businessCallqueueText(type) {
            switch(type) {
                case 0:
                return 'Inviato'
                case 1:
                return 'Non Inviato'
                default:
                return type
            }
        },

        callqueueOutcomeText(codice) {
            const testi = {
                not_interested: 'Non interessato',
                discarded: 'Scartato',
                ghosted: 'Non risponde più',
                unreachable: 'Non raggiungibile',
                human_requested: 'Chiede un operatore',
                request_call: 'Chiede richiamata',
                book_call: 'Appuntamento',
                goal_reached: 'Obiettivo raggiunto',
                goal_not_reached: 'Obiettivo non raggiunto',
                goal_handed_off: 'Passato a un operatore',
                update_contact: 'Dati aggiornati',
                first_message_received: 'Ha risposto',
                message_received: 'Messaggio ricevuto',
                button_pressed: 'Pulsante premuto',
                file_received: 'File ricevuto',
                url_received: 'Link ricevuto',
            }
            return testi[codice] || codice
        },
        callqueueOutcomeColor(codice) {
            const colori = {
                answered: 'success',
                not_answered: 'warning',
                busy: 'orange',
                rejected: 'error',
                voicemail: 'info',
                error: 'error',
                goal_reached: 'success',
                book_call: 'success',
                request_call: 'info',
                human_requested: 'info',
                not_interested: 'error',
                discarded: 'error',
                unreachable: 'error',
                ghosted: 'warning',
                goal_not_reached: 'warning',
            }
            return colori[codice] || 'grey'
        },

        transOptionsRole(option_name) {
            switch(option_name) {
                case 'true':
                return 'Si'
                case 'false':
                return 'No'
                case 'owner':
                return 'Responsabile'
                case 'user':
                return 'Creatore'
                case 'users':
                return 'Associato'
                case 'group':
                return 'Gruppo'
                case 'group_user':
                return 'Gruppo + Membri'
                // Scope HR (Modulo Risorse Umane via Laravel Policy)
                case 'self':
                return 'Solo i propri dati'
                case 'direct_reports':
                return 'I propri riporti diretti'
                case 'department':
                return 'Il proprio reparto'
                case 'department_tree':
                return 'Reparto + sottoreparti'
                case 'all':
                return 'Tutti'
                default:
                return 'X'
            }
        },

        // Set varible selected in Quill Editor
        setVaribleTexEditor(QuillEditor, variable) {
            let range = QuillEditor.getSelection(true)
            if (range.length == 0) {
                QuillEditor.insertText(range.index, '{{'+variable+'}}')
            } else if(range.length > 0){
                QuillEditor.deleteText(range.index, range.length)
                QuillEditor.insertText(range.index, '{{'+variable+'}}')
            }
        },


        // ROUTER UTILITIES 
        chooseRedirect(router, response, redirect, modelDef) {
            try {
                // IF BACK TURN BACK
                if( _.hasIn(redirect, 'back')) {
                    router.go(redirect.back)
                } else if (redirect && redirect.dialog) {
                    // DO NOTHING, MANAGE IN COMPONENT
                } else {
                    let params = _.hasIn(redirect, 'params') ? redirect.params : {}
                    let query = _.hasIn(redirect, 'query') ? redirect.query : {}
                    // TURN BACK IN MODEL SPECIFIED AND EREDITED BY CRUD
                    if(redirect && _.hasIn(redirect, 'modelDef')) {
                        if(_.hasIn(redirect, 'id')) {
                            router.push({ name: redirect.modelDef, params: { id: parseInt(redirect.id), ...params }, query: query})
                        } else if(response.data.id) {
                            router.push({ name: redirect.modelDef, params: { id: parseInt(response.data.id), ...params }, query: query})
                        } else {
                            router.push({ name: redirect.modelDef })
                        }
                    } else {
                        // IF IN CREATE
                        if(response.data.id) {
                            router.push({ name: modelDef + '-show', params: { id: parseInt(response.data.id), ...params }, query: query})
                        }
                        // ELSE IN EDIT AND TURN IN SHOW
                        else {
                            router.push({ name: modelDef + '-show'})
                        }
                    }
                }
            } catch (error) {
                if (error.name !== 'NavigationDuplicated') {
                    throw error;
                }
             }
        },

        // Mappa il discriminatore `business` (campo della tabella companies)
        // sulla route Vue corrispondente per la pagina di dettaglio.
        // 0=company, 1=supplier, 2=lead, 3=prospect.
        businessRouteName(business) {
            switch (Number(business)) {
                case 0: return 'companies-show'
                case 1: return 'suppliers-show'
                case 2: return 'leads-show'
                case 3: return 'prospects-show'
                default: return 'companies-show'
            }
        },

        goToBusiness(router, business, id) {
            this.goTo(router, this.businessRouteName(business), id)
        },

        goTo(router, name, id, defaultInput = null, params = {}, query = {}) {
            if(!(router.history.current.name == name && router.history.current.params.id == id)) {
                try {
                    let routeObj = {
                        name: name,
                        params: id ? { id: parseInt(id), defaultInput: defaultInput, ...params } : { defaultInput: defaultInput, ...params }
                    }
                    // Aggiungere query params se presenti
                    if (Object.keys(query).length > 0) {
                        routeObj.query = query
                    }
                    router.push(routeObj)
                } catch (error) {
                    if (error.name !== 'NavigationDuplicated') {
                        throw error;
                    }
                }
            }
        },       

        getFile(store, url, filename, preview = false) {
            return new Promise((resolve, reject) => {
                url = _.startsWith(url, '/api') ? url : '/api' + url

                // Encode dei segmenti del path per gestire caratteri speciali come #, ?, &
                url = url.split('/').map(segment => encodeURIComponent(segment)).join('/')

                fetch(store.getters.baseUrl + url, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                        'Authorization': 'Bearer ' + store.getters.token
                    }
                })
                .then(r => {
                    r.blob()
                    .then((blob) => {
                        if(preview) {
                            // Su Capacitor mobile, apri il file con l'app nativa
                            if (capacitorService.isNative) {
                                this.saveCapacitorFile(blob, filename)
                                resolve(null)
                            } else {
                                resolve(this.previewFile(blob))
                            }
                        } else {
                            this.showFile(blob, filename)

                            resolve()
                        }
                    })
                })
                .catch(err => {
                    console.error('[getFile] Errore fetch:', err)
                    reject(err)
                })
            })
        },   

        previewFile(blob) {
            var newBlob = new Blob([blob], {type: blob.type})
            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(newBlob)
              return
            }
            // For other browsers: 
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob)
            return data
        },

        openFile(store, url, filename, method = 'GET', params = {}) {
            let options = {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    'Authorization': 'Bearer ' + store.getters.token
                },
                method: method
            }
            if(!_.isEmpty(params)){
                options['body'] = JSON.stringify(params)
            }
            // Promise<boolean>: true se il file è arrivato (l'errore lo segnala già lo snackbar)
            return fetch(store.getters.baseUrl+'/api'+url, options)
            .then(r => {
                if (!r.ok) {
                    r.json().then(body => {
                        store.commit('setSnackbar', {timeout: 6000, text: body.message ? body.message : 'Ops.. Qualcosa è andato storto', value: true, color: 'error'})
                    })                    
                    return false
                }
                for (var pair of r.headers.entries()) {
                    if(pair[0] == 'content-disposition' && pair[1].startsWith('filename=')) {
                        filename = pair[1].split('filename=')[1].split(';')[0];
                        filename = filename.substr(1).substring(0, filename.length - 2);
                        break;
                    }
                }
                return r.blob()
                .then(blob => {
                    this.showFile(blob, filename)
                    return true
                })
            })
        },

        // Come openFile, ma apre il PDF nel viewer del browser invece di scaricarlo.
        // La scheda va aperta subito, dentro il gesto utente: un window.open dopo la
        // fetch verrebbe fermato dal popup blocker. Su nativo resta il salvataggio.
        openFileInline(store, url, filename, method = 'GET', params = {}) {
            if (capacitorService.isNative) {
                return this.openFile(store, url, filename, method, params)
            }
            const tab = window.open('', '_blank')
            if (!tab) {
                // popup bloccato: si delega tutto al download classico, che
                // recupera anche il nome file dal Content-Disposition
                return this.openFile(store, url, filename, method, params)
            }
            let options = {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    'Authorization': 'Bearer ' + store.getters.token
                },
                method: method
            }
            if(!_.isEmpty(params)){
                options['body'] = JSON.stringify(params)
            }
            fetch(store.getters.baseUrl+'/api'+url, options)
            .then(r => {
                if (!r.ok) {
                    tab.close()
                    r.json().then(body => {
                        store.commit('setSnackbar', {timeout: 6000, text: body.message ? body.message : 'Ops.. Qualcosa è andato storto', value: true, color: 'error'})
                    }).catch(() => {
                        // risposta d'errore non JSON: snackbar generico
                        store.commit('setSnackbar', {timeout: 6000, text: 'Ops.. Qualcosa è andato storto', value: true, color: 'error'})
                    })
                    return
                }
                r.blob().then(blob => {
                    // il blob va ritipizzato a PDF, altrimenti il viewer non si apre
                    const data = window.URL.createObjectURL(new Blob([blob], {type: 'application/pdf'}))
                    tab.location = data
                    // niente revoke: la scheda usa l'ObjectURL finché resta aperta
                })
            })
            .catch(() => {
                tab.close()
                store.commit('setSnackbar', {timeout: 6000, text: 'Ops.. Qualcosa è andato storto', value: true, color: 'error'})
            })
        },

        generateZip(store, url, params = {}) {
			this.axios.post(url, params).then(response => {
                let snackmessage = ''
                let snackcolor = ''
                if(response.data.status == 'fail'){
                    snackmessage = response.data.message
                    snackcolor = 'warning'
                } else{
                    snackmessage = 'Generazione archivio avviata'
                    snackcolor = 'success'
                }
                store.commit('setSnackbar', {timeout: 6000, text: snackmessage, value: true, color: snackcolor})
            }, response => {
				// error callback
			})
        },
        /**
         * Salva un file su dispositivo mobile usando Capacitor Filesystem e lo apre
         * @param {Blob} DataBlob - Il blob del file da salvare
         * @param {string} filename - Nome del file
         */
        async saveCapacitorFile(DataBlob, filename) {
            try {
                // Determina il MIME type dal blob
                const mimeType = DataBlob.type || 'application/pdf'

                // Converti il Blob in base64 usando Promise
                const base64Data = await new Promise((resolve, reject) => {
                    const reader = new FileReader()
                    reader.onloadend = () => {
                        const base64 = reader.result.split(',')[1]
                        resolve(base64)
                    }
                    reader.onerror = reject
                    reader.readAsDataURL(DataBlob)
                })

                // Salva il file nella directory Cache (funziona senza permessi speciali)
                const result = await Filesystem.writeFile({
                    path: filename,
                    data: base64Data,
                    directory: Directory.Cache,
                })

                // Apri il file con l'app predefinita
                await FileOpener.open({
                    filePath: result.uri,
                    contentType: mimeType,
                })

            } catch (error) {
                console.error('Errore salvataggio/apertura file:', error)
                $store.commit('setSnackbar', {
                    timeout: 6000,
                    text: 'Errore nell\'apertura del file: ' + (error.message || 'errore sconosciuto'),
                    value: true,
                    color: 'error'
                })
            }
        },

        showFile(blob, filename) {
            // Usa Capacitor se siamo su piattaforma nativa
            if (capacitorService.isNative) {
                var newBlob = new Blob([blob], {type: blob.type})
                this.saveCapacitorFile(newBlob, filename)
                return
            }

            let userAgent = window.navigator.userAgent
            if (window.navigator.msSaveOrOpenBlob) { //IE 11+
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else if (userAgent.match('CriOS')) { //Chrome iOS
                var reader = new FileReader();
                reader.onloadend = function () { window.open(reader.result);};
                reader.readAsDataURL(blob);
            } else if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) { //Safari & Opera iOS
                var url = window.URL.createObjectURL(blob);
                window.location.href = url;
            } else {
                // otherwise only Chrome works like it should
                // It is necessary to create a new blob object with mime-type explicitly set
                var newBlob = new Blob([blob], {type: blob.type})
                
                // For other browsers: 
                // Create a link pointing to the ObjectURL containing the blob.
                const data = window.URL.createObjectURL(newBlob)
                var link = document.createElement('a')
                link.href = data
                link.setAttribute("target", "_blank")
                link.download=filename
                //   link.style.display = 'none'
                //   document.body.appendChild(link)
                link.click()
                //   document.body.removeChild(link)
                setTimeout(function(){
                    // For Firefox it is necessary to delay revoking the ObjectURL
                    window.URL.revokeObjectURL(data)
                }, 100)
            }
        },

        changeNotificationStatus(notifications, status) {
            return this.axios.put('notifications/', {status, notifications}).then(response => {
                this.$eventBusUtility.$emit('updateNotifications', true)
                return response
            }, response => {
                // error callback
            })
        },

        toggleFullScreen() {
            let doc = window.document;
            let docEl = doc.documentElement;

            let requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
            let cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

            if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
                requestFullScreen.call(docEl);
            }
            else {
              cancelFullScreen.call(doc);
            }
        },

        exportCSV(theaders, selected, title) {
            let csv = [];
            let headers =[];
            let row = []
            // Take headers
            _.forEach(theaders, (header) => {
                headers.push(header.text);
            })
            // Write first row of headers
            csv.push(headers.join(";"));        
            // Take all tr -> forEach tr take cell -> forEach cell check if is checked
            _.each(selected, (obj) => {
                row = []
                _.forEach(theaders, (header) => {
                    let val = obj[header.text_value ? header.text_value : header.value]
                    if(Array.isArray(val) && header.subkey)
                        val = val.map((item,i) => {
                            return item[header.subkey]
                        }).join(',')
                    else if(!isNaN(val) && val != undefined)
                        val = val.toString().replace(/[.]/, ",")

                    row.push(val);
                })
                csv.push(row.join(";"))
            })
            this.downloadCSV(csv.join("\n"), title)
        },

        downloadCSV(csv, filename) {
            let csvFile;
            let downloadLink;

            // CSV file
            csvFile = new Blob([csv], {type: "text/csv"});
            // Download link
            downloadLink = document.createElement("a");
            // File name
            downloadLink.download = filename + '.csv';
            // Create a link to the file
            downloadLink.href = window.URL.createObjectURL(csvFile);
            // Hide download link
            downloadLink.style.display = "none";
            // Add the link to DOM
            document.body.appendChild(downloadLink);
            // Click download link
            downloadLink.click();
            document.body.removeChild(downloadLink);
        },

        fieldsGeneratorConditions(field, event, fieldsset, model, support = null, defaultInput = {}) {
            let targets = field.targets
            let promises = []
            if(typeof event === 'undefined') {
                Vue.set(model, field.key, null) // set null instead of undefined
            }
            if (typeof targets === 'undefined')
                return promises
            
            // Un valore passato esplicitamente al form (defaultInput, es. il sezionale della causale dalla commessa)
            // vince su quello derivato da un altro campo (es. il sezionale ereditato dall'azienda)
            const lockedByDefault = (key) => !!defaultInput && Object.prototype.hasOwnProperty.call(defaultInput, key)

            // Campi le cui opzioni sono ricaricate da un altro campo (target cascade con options): chiave -> genitori
            const cascadeParents = {}
            _.forEach(fieldsset.fields, (parent) => {
                _.forEach(parent.targets, (t) => {
                    if(t.type === 'cascade' && typeof t.options === 'undefined') {
                        (cascadeParents[t.key] = cascadeParents[t.key] || []).push(parent.key)
                    }
                })
            })

            // Il valore passato per un campo dipendente (es. il progetto della commessa) vale finche' i genitori passati
            // al form (es. l'azienda della commessa) restano quelli: se l'utente ne cambia uno, lo si rimette solo se e'
            // tra le opzioni del campo, altrimenti resterebbe nel model senza vedersi nella select e verrebbe salvato
            const defaultStillValid = (key, value) => {
                const parents = cascadeParents[key]
                if(!parents || value === null || typeof value === 'undefined' || value === '')
                    return true
                if(!parents.some((p) => lockedByDefault(p) && model[p] != defaultInput[p]))
                    return true
                const dependent = fieldsset.fields.find((f) => f.key === key)
                // Opzioni non verificabili: si tiene il comportamento di prima
                if(!dependent || !Array.isArray(dependent.options))
                    return true
                const itemValue = dependent.item_value ? dependent.item_value : 'value'
                // Confronto come stringa: l'id puo' arrivare come "2019" da una route e come 2019 dalle opzioni
                const valueOf = (v) => String(v !== null && typeof v === 'object' ? v[itemValue] : v)
                const values = Array.isArray(value) ? value : [value]
                return values.every((v) => dependent.options.some((o) => valueOf(o) === valueOf(v)))
            }

            // Il campo ha ancora il valore passato al form. I vuoti si equivalgono: null, '' o il NaN di un
            // parseInt su una query assente (es. company_id nelle rotte dei ticket da asset o contratto)
            const isEmptyValue = (v) => v === null || typeof v === 'undefined' || v === '' || Number.isNaN(v)
            const atDefault = (key) => lockedByDefault(key)
                && (model[key] == defaultInput[key] || (isEmptyValue(model[key]) && isEmptyValue(defaultInput[key])))

            // Valore da scrivere in un campo derivato dal campo cambiato, fuori dal ricaricamento delle opzioni (target con
            // options, campo padre svuotato): se il campo derivato ha un valore passato al form e quello cambiato ha ancora
            // il suo (es. all'apertura, quando checkDefaultInput lancia le cascade) vince il valore passato, come la
            // condizione di pagamento del DDT d'origine nel reso; se l'utente cambia il campo padre vale quello derivato
            const derivedOrDefault = (key, derived) => lockedByDefault(key) && atDefault(field.key) ? defaultInput[key] : derived

            _.forEach(targets, (target) => {
                let matched = false
                fieldsset.fields.filter((f) => {
                    if (f.key === target.key) {
                        matched = true
                        promises.push(new Promise((resolve, reject) => {
                            if(target.type == 'cascade') {
                                let urlForOptions = ''
                                if(target.url != '') {
                                    urlForOptions = 'get-related/'
                                }
                                // If delete primary select the second select must be empty
                                if (!model[field.key]) {
                                    if(target.fallback) {
                                        urlForOptions += target.fallback.parent_model + '/' + model[target.fallback.parent_key] + '/' + target.url
                                        this.axios.get(urlForOptions).then(response => {
                                            Vue.set(f, 'options', response.data)
                                            resolve(f)
                                        }, response => {

                                        })
                                    } else {

                                        if(typeof target.options === 'undefined') {
                                            Vue.set(f, 'options', [])
                                        }
                                        Vue.set(model, f.key, derivedOrDefault(f.key, typeof f.default !== 'undefined' ? f.default : null))
                                        resolve(f)
                                    }
                                } else {
                                    let split = []
                                    if(f.parent_type === 'morphTo') {
                                        // split projects_2 construct project/2/tasklists
                                        split = _.split(model[field.key], '_', 2)
                                        urlForOptions += split[0] + '/' + split[1] + '/' + target.url

                                    } else if(f.parent_type === 'belongsTo') {
                                        // companycategory/3/subcompanycategories
                                        urlForOptions += target.url_model + '/' + model[field.key] + '/' + target.url
                                    }
                                    this.axios.get(urlForOptions + '?lite=1').then(response => {
                                        // Set select options in child select
                                        if(typeof target.options !== 'undefined') {
                                            if(response.data.model[target.key] != null)
                                                Vue.set(model, target.key, derivedOrDefault(target.key, response.data.model[target.key]))
                                        }
                                        else {
                                            Vue.set(f, 'options', response.data)
                                            if(typeof target.default !== 'undefined') {
                                                let valid_options = f.options.filter((o) => {
                                                    return typeof o.barred === 'undefined' || !!!o.barred
                                                })
                                                if(!$store.getters.checkSettings('disable_single_option') && target.default == 'single_option' && valid_options.length == 1) {
                                                    Vue.set(model, f.key, valid_options[0].value)
                                                } else {
                                                    Vue.set(model, f.key, null)
                                                }
                                            } else {
                                                Vue.set(model, f.key, null)
                                            }
                                            
                                            if(defaultInput)  {
                                                // Riapplica il valore passato al form solo per il campo appena azzerato (es. il
                                                // progetto della commessa dopo la cascade dell'azienda), se e' ancora valido per i
                                                // genitori scelti dall'utente. Gli altri valori passati non si toccano: l'utente
                                                // puo' averli cambiati (es. l'azienda) e una cascade di un altro campo non li riscrive
                                                if(lockedByDefault(f.key) && model[f.key] != defaultInput[f.key] && defaultStillValid(f.key, defaultInput[f.key]))
                                                    Vue.set(model, f.key, defaultInput[f.key])
                                            } else if(f.auto_select && typeof f.options[0] !== 'undefined') {
                                                Vue.set(model, f.key, f.options[0])
                                            } else if(f.auto_select_default) {
                                                _.forEach(f.options, (option, o) => {
                                                    if(option.auto_select_default && option.auto_select_default == 1) {
                                                        Vue.set(model, f.key, f.options[o].value)
                                                    }
                                                })
                                            }
                                        }

                                        resolve(f)

                                    }, response => {

                                    })
                                }
                            } else if(target.type == 'change_other') {
                                if (!model[field.key]) {
                                    /*Vue.set(f, 'options', [])
                                    model[f.key] = target.empty_value*/
                                } else {
                                    let result = false

                                    _.forEach(target.conditions, (condition_or) => {
                                        let and_result = true
                                        _.forEach(condition_or, (condition_and) => {
                                            let condition_value
                                            if(typeof condition_and.field !== 'undefined'){
                                                condition_value = model[condition_and.field]
                                            } else {
                                                field.options.filter((option) => {
                                                    if (option.value === model[field.key]) {
                                                        condition_value = option[condition_and.key]
                                                    }
                                                })
                                            }
                                            if(!this.comparators[condition_and.compare](condition_value, condition_and.value)){
                                                and_result = false
                                                return false
                                            }
                                        })

                                        if(!result && and_result){
                                            result = true
                                            return false
                                        }
                                    })
                                    if(result){
                                        if(typeof target.real_key !== 'undefined'){
                                            Vue.nextTick(function () {
                                                Vue.set(support, target.real_key, target.real_set)
                                            })
                                        }
                                        Vue.set(model, f.key, target.set)
                                        resolve(f)
                                    }
                                }
                            } else if(target.type == 'simple') {
                                if(lockedByDefault(f.key)) {
                                    resolve(f)
                                } else if(model[target.model_key]) {
                                    this.axios.get(target.url + '/' + model[target.model_key] + '?lite=1').then(response => {
                                        Vue.set(model, f.key, response.data.model[target.relation_field])
                                        resolve(f)
                                    })
                                }
                            } else if(target.type == 'simple_notempty') {
                                if(lockedByDefault(f.key)) {
                                    resolve(f)
                                } else if(model[target.model_key]) {
                                    this.axios.get(target.url + '/' + model[target.model_key] + '?lite=1').then(response => {
                                        if(typeof response.data.model[target.relation_field] !== 'undefined' && response.data.model[target.relation_field] != null) {
                                            Vue.set(model, f.key, response.data.model[target.relation_field])
                                        }
                                        resolve(f)
                                    })
                                }
                            } else if(target.type == 'sectional') {
                                let dataObject = {
                                    id: model.id,
                                    model: target.model,
                                    sectional_id: model.sectional_id,
                                    date: model.date ? model.date : model.quotation_date,
                                }
                                this.axios.post(target.url, dataObject).then(response => {
                                    Vue.set(model, 'number', response.data.data)
                                    resolve(f)
                                })
                            }
                        }))
                    }
                })
                // Fallback: target simple senza campo corrispondente — setta direttamente sul model
                if (!matched && target.type === 'simple' && model[target.model_key] && !lockedByDefault(target.key)) {
                    this.axios.get(target.url + '/' + model[target.model_key] + '?lite=1').then(response => {
                        Vue.set(model, target.key, response.data.model[target.relation_field])
                    })
                }
            })
            return promises
        },

        formatAddress(model, suffix = '') {
            if(model) {
                let address = ''
                suffix = suffix == '' ? suffix : suffix + '_' 
                if(model[suffix + 'address_street']) {
                    address += model[suffix + 'address_street']
                }
                if(model[suffix + 'address_number']) {
                    if(model[suffix + 'address_street']) {
                        address += ', '
                    }
                    address += model[suffix + 'address_number']
                } else {
                    //address += ','
                }
                if(model[suffix + 'address_zipcode']) {
                    address += ' ' + model[suffix + 'address_zipcode']
                }
                if(model[suffix + 'address_city']) {
                    address += ' ' + model[suffix + 'address_city']
                }
                if(model[suffix + 'address_province']) {
                    address += ' ' + model[suffix + 'address_province']
                }
                
                return address
            }
        },

        parseDate(date) {
            // parse from dd/mm/yyyy to yyyy-mm-dd
            if (!date) return null

            let parsedDate = moment(date, 'DD/MM/YYYY')

            if(parsedDate.isValid()) return parsedDate.format('YYYY-MM-DD')
            else return ''
        },

        formatDate(date){
            if (!date) return null
            return moment(date).format('DD/MM/YYYY')
        },

        formatMonth(date){
            if (!date) return null

            const [year, month] = date.split('-')
            return `${month}/${year}`
        },

        appendFormdata(FormData, data, name){
            name = name || '';
            if (typeof data === 'object' && !(data instanceof File)){
                _.forEach(data, (value, index) => {
                    if (name == ''){
                        this.appendFormdata(FormData, this.tryParseBoolean(value), index);
                    } else {
                        this.appendFormdata(FormData, this.tryParseBoolean(value), name + '['+index+']');
                    }
                })
            } else {
                FormData.append(name, this.tryParseBoolean(data));
            }
        },

        tryParseBoolean(value) {
            if (value === true) {
                return 1
            }
            if (value === false) {
                return 0
            }
            return value
        },

        goToLink(url) {
            if (!url.match(/^https?:\/\//i)) {
                url = 'http://' + url;
            }
            window.open(url, '_blank');
        },

        // custom filter function for FieldsGenerator autocomplete
        customFilter(item, queryText, itemText, searchKeys) {
            let result = itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
            if(!searchKeys || result) {
                return result
            }
            
            _.forEach(searchKeys, (searchKey, k) => {
                if(item[searchKey] != null && searchKey !== 'barred') {

                    if($store.getters.checkSettings('product_code_search') && searchKey == 'code') {
                        result = item[searchKey].toLocaleLowerCase() == queryText.toLocaleLowerCase()
                    } else {
                        result = item[searchKey].toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
                    }
                    return !result
                }
            })
            return result
        },


        setSnackbar(response, store) {
            let snackmessage = ''
            let	snackcolor = ''
            if(response.data.status == 'message'){
                snackmessage = response.data.message
                snackcolor = 'warning'
            } else {
                snackmessage = typeof response.data.message !== 'undefined' ? response.data.message : 'Elementi eliminati con successo.'
                snackcolor = 'success'
            }
            store.commit('setSnackbar', {timeout: 6000, text: snackmessage, value: true, color: snackcolor})
        },

        lightOrDark(color) {

            // Variables for red, green, blue values
            var r, g, b, hsp;
            
            // Check the format of the color, HEX or RGB?
            if (color.match(/^rgb/)) {
        
                // If HEX --> store the red, green, blue values in separate variables
                color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
                
                r = color[1];
                g = color[2];
                b = color[3];
            } 
            else {
                
                // If RGB --> Convert it to HEX: http://gist.github.com/983661
                color = +("0x" + color.slice(1).replace( 
                color.length < 5 && /./g, '$&$&'));
        
                r = color >> 16;
                g = color >> 8 & 255;
                b = color & 255;
            }
            
            // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
            hsp = Math.sqrt(
            0.299 * (r * r) +
            0.587 * (g * g) +
            0.114 * (b * b)
            );
        
            // Using the HSP value, determine whether the color is light or dark
            //if (hsp>127.5) {
            if (hsp>180) {
        
                return 'light';
            } 
            else {
        
                return 'dark';
            }
        },


        checkDefaultInput(self, modelKey) {
            let index = null
            let field = null
            _.forEach(self.defaultInput, (value, key) => {
                Vue.set(self[modelKey], key, value)
                // manage async filed with default option
                index = self.fieldsset.fields.findIndex((f, index) => {
                    return f.key == key
                })
                if(index > -1) {
                    field = self.fieldsset.fields[index]
                
                    if(field && field.async !== 'undefined' && field.async) {
                        this.axios.get(field.async_url, {
                            params: {
                                id: value
                            }
                        }).then(response => {
                            let new_index = self.fieldsset.fields.findIndex((f, index) => {
                                return f.key == key
                            })
                            Vue.set(self.fieldsset.fields[new_index], 'options', response.data.options)
                            Vue.set(self.fieldsset.fields[new_index], 'searching', false)
                        })
                    }
                }

                const fieldRef = self.$refs.fieldsgenerator && self.$refs.fieldsgenerator.$refs[key]
                if(fieldRef && fieldRef[0]) {
                    fieldRef[0].$emit('change', [value])
                }
            })
        },     
        
        showButton(button) {
            if (button.module_permission !== undefined) {
                return $store.getters.checkModulePermissions(button.module_permission)
            }

            if (button.settings_permission !== undefined) {
                if (button.settings_value) {
                    return $store.getters.getSetting(button.settings_permission) == button.settings_value
                } else {
                    return $store.getters.checkSettings(button.settings_permission)
                }
            }

            // visibile solo se il setting e' spento (o mancante)
            if (button.settings_permission_not !== undefined) {
                return !$store.getters.checkSettings(button.settings_permission_not)
            }

            return true
        },

    }
})
